import { render, staticRenderFns } from "./InsBanner.vue?vue&type=template&id=c2aed194&scoped=true&"
import script from "./InsBanner.vue?vue&type=script&lang=ts&"
export * from "./InsBanner.vue?vue&type=script&lang=ts&"
import style0 from "./InsBanner.vue?vue&type=style&index=0&lang=less&"
import style1 from "./InsBanner.vue?vue&type=style&index=1&id=c2aed194&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2aed194",
  null
  
)

export default component.exports